<router-outlet></router-outlet>

<!-- <div *ngIf="updateMessage">{{ updateMessage }}</div>
<button *ngIf="showRestart" (click)="restartApp()">Restart to Update</button> -->
<!-- <app-treeview [datasource]="categoryTest"></app-treeview> -->
<!-- <app-ana-chatbot width="550px" height="600px" [x]="x" [y]="y" inputHeight="100px" label="질문" placeholder="내용을 입력하세요.."
  [maxlength]="500" name="SBL AI Excellence" image="./assets/images/i_bot.png"></app-ana-chatbot> -->
  <!-- <app-ratio-and-template></app-ratio-and-template>
  <div style="display: flex;">
    <app-clip-and-subtitle [clips]="clips" style="width: 80%;"></app-clip-and-subtitle>
    <div style="display: flex; flex-direction: column; gap: 30px;">
      <app-title-check [projectInfo]="projectInfo"></app-title-check>
      <app-shorform-buttons></app-shorform-buttons>
    </div>
  </div> -->
